// frontend/src/components/Layout.js - UPDATED WITH FIXED TECHNICIAN PARTS MENU
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Layout.css';

const getUserFromStorage = () => {
  return {
    name: localStorage.getItem('erp_username') || 'User',
    role: localStorage.getItem('erp_user_role') || 'staff'
  };
};

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [user, setUser] = useState(getUserFromStorage());
  const [expandedMenus, setExpandedMenus] = useState([]);
  
  // Check if user is authenticated on component mount
  useEffect(() => {
    const token = localStorage.getItem('erp_auth_token');
    if (!token) {
      navigate('/login');
    }
    
    // Update user state from storage
    setUser(getUserFromStorage());
    
    // Automatically expand menu based on current path
    const path = location.pathname;
    let menusToExpand = [];
    
    if (path.startsWith('/school-projects')) {
      menusToExpand.push('school-projects');
      
      // If it's a technician parts route, also expand technician-parts menu
      if (path.includes('/technician-parts')) {
        menusToExpand.push('technician-parts');
      }
    }
    
    if (path.startsWith('/credit')) {
      menusToExpand.push('credit');
    }
    
    setExpandedMenus(menusToExpand);
  }, [navigate, location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem('erp_auth_token');
    localStorage.removeItem('erp_user_role');
    localStorage.removeItem('erp_username');
    navigate('/login');
  };

  const toggleMenu = (menu) => {
    setExpandedMenus(prev => 
      prev.includes(menu) 
        ? prev.filter(m => m !== menu)
        : [...prev, menu]
    );
  };

  // Menu items with role-based permissions - SIMPLIFIED VERSION
  const menuItems = [
    { 
      path: '/dashboard', 
      icon: '📊', 
      label: 'Dashboard', 
      roles: ['admin', 'staff'],
      isMainMenu: true 
    },
    { 
      path: '/pos', 
      icon: '🛒', 
      label: 'POS', 
      roles: ['admin', 'staff'],
      isMainMenu: true 
    },
    { 
      path: '/pos/sales', 
      icon: '📋', 
      label: 'POS Sales', 
      roles: ['admin', 'staff'],
      isMainMenu: true 
    },
    { 
      path: '/products', 
      icon: '📦', 
      label: 'Products', 
      roles: ['admin'],
      isMainMenu: true 
    },
    { 
      path: '/customers', 
      icon: '👥', 
      label: 'Customers', 
      roles: ['admin'],
      isMainMenu: true 
    },
   /* 
   // CREDIT MANAGEMENT SECTION
    { 
      type: 'group',
      key: 'credit',
      icon: '💳',
      label: 'Credit Management',
      roles: ['admin', 'staff'],
      children: [
        { path: '/credit/dashboard', icon: '📊', label: 'Credit Dashboard', roles: ['admin', 'staff'] },
        { path: '/credit/payments', icon: '💰', label: 'Payment Collection', roles: ['admin', 'staff'] },
        { path: '/credit/customers', icon: '👥', label: 'Credit Customers', roles: ['admin'] },
        { path: '/credit/overdue', icon: '⚠️', label: 'Overdue Accounts', roles: ['admin'] },
        { path: '/credit/reports', icon: '📈', label: 'Credit Reports', roles: ['admin'] },
      ]
    },
    
    // REPAIRS SECTION
    { 
      path: '/repairs', 
      icon: '🔧', 
      label: 'Repairs', 
      roles: ['admin', 'staff'],
      isMainMenu: true 
    },

    { 
      path: '/invoices', 
      icon: '🧾', 
      label: 'Invoices', 
      roles: ['admin'],
      isMainMenu: true 
    },
    { 
      path: '/sales', 
      icon: '💰', 
      label: 'Sales', 
      roles: ['admin', 'staff'],
      isMainMenu: true 
    },
    { 
      path: '/quotations', 
      icon: '📝', 
      label: 'Quotations', 
      roles: ['admin', 'staff'],
      isMainMenu: true 
    },
    { 
      path: '/rentals', 
      icon: '🔧', 
      label: 'Rentals', 
      roles: ['admin', 'staff'],
      isMainMenu: true 
    },
    
    
    // SCHOOL PROJECTS SECTION - SIMPLIFIED VERSION
    { 
      type: 'group',
      key: 'school-projects',
      icon: '🏫',
      label: 'School Projects',
      roles: ['admin', 'staff'],
      children: [
        { path: '/school-projects/dashboard', icon: '📊', label: 'Dashboard', roles: ['admin', 'staff'] },
        { path: '/school-projects/technician-parts', icon: '🔧', label: 'Issue Parts', roles: ['admin', 'staff'] },
        { path: '/school-projects/inventory', icon: '📦', label: 'Inventory', roles: ['admin'] },
        { path: '/school-projects/projects', icon: '📋', label: 'Projects', roles: ['admin', 'staff'] },
        { path: '/school-projects/schools', icon: '🏫', label: 'Schools', roles: ['admin'] },        
        { path: '/school-projects/technicians', icon: '👨‍🔧', label: 'Technicians', roles: ['admin'] },       
        { path: '/school-projects/purchases', icon: '🛒', label: 'Purchases', roles: ['admin'] },
        { path: '/school-projects/reports', icon: '📈', label: 'Reports', roles: ['admin'] },
        { path: '/school-projects/settings', icon: '⚙️', label: 'Settings', roles: ['admin'] },
      ]
    },
    */

    
    
    // REPORTS SECTION
    { 
      path: '/reports', 
      icon: '📈', 
      label: 'Reports', 
      roles: ['admin'],
      isMainMenu: true 
    },
    
    { 
      path: '/users', 
      icon: '👥', 
      label: 'User Management', 
      roles: ['admin'],
      isMainMenu: true 
    },
    
    /*{ 
      path: '/settings', 
      icon: '⚙️', label: 'Settings', 
      roles: ['admin'],
      isMainMenu: true 
    }, */
  ];

  // Individual menu items (for non-group items)
  const individualMenuItems = menuItems.filter(item => 
    !item.type && item.isMainMenu && item.roles.includes(user.role)
  );

  // Group menu items
  const groupMenuItems = menuItems.filter(item => 
    item.type === 'group' && item.roles.includes(user.role)
  );

  const getActiveMenuLabel = () => {
    // Check individual menu items first
    const current = individualMenuItems.find(item => item.path === location.pathname);
    if (current) return current.label;
    
    // Check group menu items children
    for (const group of groupMenuItems) {
      const child = group.children.find(item => item.path === location.pathname);
      if (child) return child.label;
    }
    
    // Handle dynamic routes
    if (location.pathname.startsWith('/invoices/')) {
      if (location.pathname.includes('/new')) return 'Create Invoice';
      if (location.pathname.includes('/edit/')) return 'Edit Invoice';
      return 'Invoice Details';
    }
    
    if (location.pathname.startsWith('/sales/')) {
      if (location.pathname.includes('/new')) return 'Create Sale';
      if (location.pathname.includes('/edit/')) return 'Edit Sale';
      return 'Sale Details';
    }
    
    if (location.pathname.startsWith('/quotations/')) {
      if (location.pathname.includes('/new')) return 'Create Quotation';
      if (location.pathname.includes('/edit/')) return 'Edit Quotation';
      return 'Quotation Details';
    }
    
    if (location.pathname.startsWith('/pos/sales')) {
      return 'POS Sales History';
    }
    
    if (location.pathname === '/pos') {
      return 'Point of Sale';
    }
    
    // Handle credit management routes
    if (location.pathname.startsWith('/credit/')) {
      if (location.pathname === '/credit/dashboard') return 'Credit Dashboard';
      if (location.pathname === '/credit/payments') return 'Payment Collection';
      if (location.pathname === '/credit/customers') return 'Credit Customers';
      if (location.pathname === '/credit/overdue') return 'Overdue Accounts';
      return 'Credit Management';
    }
    
    // Handle school project routes
    if (location.pathname.startsWith('/school-projects/')) {
      if (location.pathname === '/school-projects') return 'School Projects';
      if (location.pathname === '/school-projects/dashboard') return 'School Projects Dashboard';
      if (location.pathname === '/school-projects/projects') return 'School Projects';
      if (location.pathname === '/school-projects/schools') return 'Schools Management';
      if (location.pathname === '/school-projects/inventory') return 'School Projects Inventory';
      if (location.pathname === '/school-projects/technicians') return 'Technicians';
      if (location.pathname === '/school-projects/technician-parts') return 'Technician Parts Management';
      if (location.pathname === '/school-projects/purchases') return 'School Projects Purchases';
      if (location.pathname === '/school-projects/reports') return 'School Projects Reports';
      if (location.pathname === '/school-projects/settings') return 'School Projects Settings';
      
      // Handle technician parts sub-routes
      if (location.pathname === '/school-projects/technician-parts/issue') return 'Issue Parts to Technician';
      if (location.pathname === '/school-projects/technician-parts/return') return 'Return Parts from Technician';
      if (location.pathname === '/school-projects/technician-parts/assignments') return 'Technician Assignments';
      if (location.pathname.startsWith('/school-projects/technician-parts/assignments/')) return 'Assignment Details';
      
      return 'School Projects';
    }
    
    // Handle school project details
    if (location.pathname.startsWith('/school-projects/projects/')) {
      if (location.pathname.includes('/new')) return 'Create School Project';
      if (location.pathname.includes('/edit/')) return 'Edit School Project';
      return 'School Project Details';
    }
    
    return 'ERP System';
  };

  // Role badge colors
  const getRoleColor = (role) => {
    switch(role) {
      case 'admin': return '#ff6b6b';
      case 'staff': return '#4ecdc4';
      case 'customer': return '#45b7d1';
      default: return '#95a5a6';
    }
  };

  // Check if a menu item is active
  const isMenuItemActive = (path) => {
    return location.pathname === path || 
           (path !== '/dashboard' && location.pathname.startsWith(path));
  };

  // Check if a group menu is expanded
  const isMenuExpanded = (menuKey) => {
    return expandedMenus.includes(menuKey);
  };

  return (
    <div className="layout-container">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">POS System</h2>
          <button 
            className="sidebar-toggle" 
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label={sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>

        <div className="user-info">
          <div className="user-avatar" style={{ backgroundColor: getRoleColor(user.role) }}>
            {user.name.charAt(0).toUpperCase()}
          </div>
          {sidebarOpen && (
            <div className="user-details">
              <h3 className="user-name">{user.name}</h3>
              <p 
                className="user-role" 
                style={{ 
                  backgroundColor: getRoleColor(user.role),
                  color: 'white',
                  padding: '4px 12px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  display: 'inline-block'
                }}
              >
                {user.role.toUpperCase()}
              </p>
            </div>
          )}
        </div>

        <nav className="sidebar-nav">
          <ul>
            {/* Individual Menu Items */}
            {individualMenuItems.map((item) => (
              <li 
                key={item.path} 
                className={`nav-item ${isMenuItemActive(item.path) ? 'active' : ''}`}
              >
                <Link to={item.path} className="nav-link">
                  <span className="nav-icon">{item.icon}</span>
                  {sidebarOpen && <span className="nav-label">{item.label}</span>}
                </Link>
              </li>
            ))}
            
            {/* Group Menu Items */}
            {groupMenuItems.map((group) => (
              <li 
                key={group.key}
                className={`nav-group ${isMenuExpanded(group.key) ? 'expanded' : ''}`}
              >
                <div 
                  className="nav-group-header"
                  onClick={() => toggleMenu(group.key)}
                >
                  <span className="nav-icon">{group.icon}</span>
                  {sidebarOpen && (
                    <>
                      <span className="nav-label">{group.label}</span>
                      <span className="nav-arrow">
                        {isMenuExpanded(group.key) ? '▼' : '▶'}
                      </span>
                    </>
                  )}
                </div>
                
                {sidebarOpen && isMenuExpanded(group.key) && (
                  <ul className="nav-group-items">
                    {group.children
                      .filter(child => child.roles.includes(user.role))
                      .map((child) => (
                        <li 
                          key={child.path}
                          className={`nav-subitem ${isMenuItemActive(child.path) ? 'active' : ''}`}
                        >
                          <Link to={child.path} className="nav-link">
                            <span className="nav-icon">{child.icon}</span>
                            <span className="nav-label">{child.label}</span>
                          </Link>
                        </li>
                      ))
                    }
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-button">
            <span className="logout-icon">🚪</span>
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="main-header">
          <h1 className="page-title">{getActiveMenuLabel()}</h1>
          <div className="header-actions">
            <span className="welcome-text">Welcome, <strong>{user.name}</strong>!</span>
            <div className="user-role-badge" style={{ 
              backgroundColor: getRoleColor(user.role),
              color: 'white',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: 'bold',
              marginLeft: '10px'
            }}>
              {user.role.toUpperCase()}
            </div>
            <div className="notifications-container">
              <button className="notification-btn">
                <span className="notification-icon">🔔</span>
                <span className="notification-badge">3</span>
              </button>
            </div>
          </div>
        </header>
        
        {/* Content Area */}
        <div className="content-area" style={{ padding: '20px' }}>
          {children}
        </div>
      </main>
    </div>
  );
}

export default Layout;